import { DocRenderer } from "@cyntler/react-doc-viewer";
import React from "react";
import JPEGViewer from "../CustomViewers/JPEGViewer";
import { Buffer } from "buffer";

const JPEGRenderer: DocRenderer = ({ mainState: { currentDocument } }) => {
  const base64 = currentDocument?.uri?.replace(
  /^data:image\/jpeg;base64,|^data:image\/jpg;base64,|^data:application\/octet-stream;base64,/i,
  ""
);
// console.log('jpeg base64-->',base64);
  if (!base64) return <div>Loading...</div>;

  try {

    const buffer = Buffer.from(base64, "base64");
    // console.log('jpeg-buffer,',buffer);

    return (
      <div style={{ willChange: "width, height, scale, min-width, max-width" }}>
        <JPEGViewer jpegBuffer={buffer} />
      </div>
    );

  } catch (err) {
    console.error("JPEG decode error:", err);
    return <div>Error decoding JPEG</div>;
  }
};
JPEGRenderer.fileTypes = ["jpg", "jpeg", "image/jpeg", "image/jpg"];
JPEGRenderer.weight = 1000;

export default JPEGRenderer;
